import React from 'react';
//import '../bootstrap.min.css';
import {Redirect, Route, Router, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    alertActions,
    consultaActions,
    equipoActions,
    notificacionActions,
    productoActions,
    userActions
} from '../_actions';
import {history} from '../_helpers';
import {
    InfoSensor,
    MisAccionesColectivas,
    MisDatos,
    MisEventos,
    MisVistas,
    NavBar,
    NavBarLateral,
    PrivateRoute
} from '../_components';
import {Alerta} from '../_components/Alerta';
import {LoginPage} from '../_components/Navegacion/LoginPage';
import {LogoutPage} from '../_components/Navegacion/LogoutPage';
import SockJsClient from '../_components/SockJsClient';
import {mqttEventosConstants} from '../_constants';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import {EquipoListado} from '../_components/EquipoListado';
import {userService} from '../_services';
import {MisEquipos} from '../_components/Equipo';
import {MisUsuarios} from '../_components/Perfil/MisUsuarios';
import authService from '../_services/authService';
import {AdmEquipos} from '../_components/admin/AdmEquipos';
import {AdmUsuarios} from '../_components/admin/AdmUsuarios';
import {AdmEmpresa} from '../_components/admin/AdmEmpresa';

const appName = process.env.REACT_APP_NAME;
const sockJsRef = React.createRef();

class App extends React.Component {
    constructor(props) {
        super(props);
        this.onMessage = this.onMessage.bind(this);
        history.listen((location, action) => {
            this.props.clearAlerts();
        });

        if (userService.estaLogueado()) {
            this.props.getLogueado();
            this.props.getEquiposPU();
        }

    }

    onDisconnect = (err)=> {
        console.log('onDisconnect', err)
    }

    onMessage(json) {
        const evento = json.eventoSocket;
        if (evento === mqttEventosConstants.NUEVO_MENSAJE)
            this.props.nuevoMensajeChat(json)
        if (evento === mqttEventosConstants.NUEVO_VALOR_SENSOR)
            this.props.nuevoValorSensor(json)
        if (evento === mqttEventosConstants.NUEVO_VALOR_PROGRAMA)
            this.props.actualizarPrograma(json.programa)
        if (evento === mqttEventosConstants.NUEVO_VALOR_COMPRA)
            this.props.actualizarCompra(json.compra)
        if (evento === mqttEventosConstants.NUEVA_NOTIFICACION)
            this.props.nuevaNotificacion(json.notificacion)
        if (evento === mqttEventosConstants.ESTADO_EQUIPO)
            this.props.cambiarEstadoEquipo(json.idEquipo, json.nuevoEstado)
        if (evento === mqttEventosConstants.NUEVO_TOKEN)
            this.props.actualizarToken(json.tokenActivo)
        if (evento === mqttEventosConstants.ESTADO_SENSOR)
            this.props.nuevoEstadoSensor(json.idSensor, json.conectado)
    }

    render() {
        const {alert, equipos, user, userData} = this.props;

        let {pathname} = history.location;
        pathname = pathname.substring(pathname.indexOf('/'), pathname.lastIndexOf('/'));
        return (
            <div>

                <Router basename={appName} history={history}>
                    {(alert.message || alert.confirm) &&
                    <Alerta data={alert}/>
                    }

                    {authService.isAuthenticated() &&
                    <SockJsClient user={userData} onDisconnect={this.onDisconnect} sensoresL={equipos.sensores} ref={sockJsRef}
                                  equipos={equipos.misEquipos}
                                  onMessage={this.onMessage}/>}
                    <NavBar/>

                    {authService.isAuthenticated() && <NavBarLateral/>}
                    <Switch>
                        <PrivateRoute exact path={"/home/listaVista"} component={EquipoListado}/>
                        <PrivateRoute exact path={"/home/listaEquipo"} component={EquipoListado}/>
                        <PrivateRoute exact path={"/home/infoSensor"} component={InfoSensor}/>
                        <PrivateRoute exact path={"/home/misVistas"} component={MisVistas}/>
                        <PrivateRoute exact path={"/home/misEquipos"} component={MisEquipos}/>
                        <PrivateRoute exact path={"/home/misAcciones"} component={MisAccionesColectivas}/>
                        <PrivateRoute exact path={"/home/misEventos"} component={MisEventos}/>

                        <PrivateRoute exact path={"/perfil/misDatos"} component={MisDatos}/>
                        <PrivateRoute exact path={"/perfil/usuarios"} component={MisUsuarios}/>

                        <PrivateRoute exact path={"/admin/equipos"} component={AdmEquipos}/>
                        <PrivateRoute exact path={"/admin/usuarios"} component={AdmUsuarios}/>
                        <PrivateRoute exact path={"/admin/empresas"} component={AdmEmpresa}/>

                        <PrivateRoute exact path={"/home/equipoNuevo"} component={MisEquipos}/>
                        <Route path={"/logout"} component={LogoutPage}/>
                        <Route path={"/login"} component={LoginPage}/>
                        <Redirect from="*" to="/home/misEquipos"/>
                    </Switch>
                </Router>
            </div>

        );
    }
}

function mapState(state) {
    const {alert, equipos, authentication} = state;
    const {user, userData} = authentication;
    return {alert, equipos, user, userData};
}

const actionCreators = {
    nuevoMensajeChat: consultaActions.nuevoMensajeChat,
    nuevoValorSensor: equipoActions.nuevoValorSensor,
    actualizarToken: userActions.actualizarToken,
    cambiarEstadoEquipo: equipoActions.cambiarEstadoEquipo,
    actualizarCompra: productoActions.actualizarCompra,
    clearAlerts: alertActions.clear,
    getLogueado: userActions.getLogueado,
    nuevaNotificacion: notificacionActions.nuevaNotificacion,
    nuevoEstadoSensor: equipoActions.nuevoEstadoSensor,
    getEquiposPU: equipoActions.getEquiposPU
};

const connectedApp = connect(mapState, actionCreators)(App);
export {connectedApp as App};